// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2y4T8","title":"ClientInsurance_title__1tcSk","itemText":"ClientInsurance_itemText__2c2Dd"};